import type { DecodeResult } from "./decoder";

/**
 * Time-window duplicate suppression keyed on decoded contents. The timestamp
 * is stamped at EMISSION, not at sighting — a code held continuously in view
 * re-emits every `windowMs`, it does not slide its own window forward.
 */
export class DuplicateFilter {
  private lastEmitted = new Map<string, number>();

  constructor(private readonly windowMs: number) {}

  filter(results: DecodeResult[], now: number): DecodeResult[] {
    if (this.windowMs <= 0) return results;
    return results.filter((r) => {
      const last = this.lastEmitted.get(r.data);
      if (last !== undefined && now - last <= this.windowMs) return false;
      this.lastEmitted.set(r.data, now);
      return true;
    });
  }
}
